import React, {useEffect, useState} from 'react'
import { Display } from '../Main/styles'
import { StatusHeader, StatusHeaderBtn, StatusHeaderTitle, StatusWrapper } from './styles'
import { useStatusList } from 'CRM/hooks/GetStatusList'
import { Table, message } from 'antd';
import StatusEdit from 'CRM/components/Edit/StatusEdit';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { StatusAdd } from 'CRM/components/Add/StatusAdd';
import {useIsMobile} from "../../components/IsMobile";

export const Status = () => {
  const IsMobile = useIsMobile()
  const [scrollPosition, setScrollPosition] = useState(0);
  const { data: token } = useToken();
  const { statusList, mutate } = useStatusList();
  const [isEdit, setIsEdit] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    if(!isEdit && IsMobile){
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    } else if(isEdit && IsMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setScrollPosition(window.scrollY);
    }
  }, [isEdit]);

  const deleteStatus = (data) => {
    const shouldEdit = window.confirm(`정말 ${data?.name}을 삭제하시겠습니까?`);
    if(shouldEdit) {
      API.delete('/system/status/' + data?.id, token + '', {})
      .then((res: any) => {
        if (res.result.success) {
          message.success('삭제되었습니다');
          mutate();
        }
      })
      .catch((err: any) => {})
    }
  }

  const mobileColumns = [
    {
      dataIndex: '',
      title: '상태관리',
      render: (value, data) => {
        return (
         <>
           <div className='date' style={{display: 'flex', justifyContent: 'flex-start'}}><p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>등록일: </p> {data?.createdAt || '-'}</div>
           <div className='name' style={{display: 'flex', justifyContent: 'flex-start'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>상태: </p> {data?.name || '-'}</div>
           <div className='color' style={{display: 'flex', justifyContent: 'flex-start'}}>
             <span style={{backgroundColor: data?.color || '#fff'}} />
             <p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>색상: </p> {data?.color || '-'}
           </div>
           <div className='desc' style={{display: 'flex', justifyContent: 'flex-start'}}><p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>설명: </p> {data?.desc || '-'}</div>
           <div className='date' style={{display: 'flex', justifyContent: 'flex-start'}}><p style={{marginRight: 5, fontWeight: 'bold', color: 'black'}}>수정일: </p> {data?.updatedAt || '-'}</div>
           <div className='btns' style={{display: 'flex', justifyContent: 'flex-start'}}>
             <button className='edit' onClick={() => {setIsEdit(true); setData(data);}}>수정</button>
             <button className='delete' onClick={() => deleteStatus(data)}>삭제</button>
           </div>
         </>
        )
      }
    }
  ]

  const columns = [
    {
      dataIndex: '',
      title: '등록일',
      render: (value, data) => {
        return (
          <div className='date'>{data?.createdAt}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '상태',
      render: (value, data) => {
        return (
          <div className='name'>{data?.name}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '색상',
      render: (value, data) => {
        return (
          <div className='color'>
            <span style={{backgroundColor: data?.color || '#fff'}} />
            {data?.color}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '설명',
      render: (value, data) => {
        return (
          <div className='desc'>{data?.desc == null || '' ? '-' : data?.desc}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '수정일',
      render: (value, data) => {
        return (
          <div className='date'>{data?.updatedAt}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '변경',
      render: (value, data) => {
        return (
          <div className='btns'>
            <button className='edit' onClick={() => {setIsEdit(true); setData(data);}}>수정</button>
            <button className='delete' onClick={() => deleteStatus(data)}>삭제</button>
          </div>
        )
      }
    },
  ];

  return (
    <Display IsMobile={IsMobile}>
      <StatusWrapper>
        <StatusHeader>
          <StatusHeaderTitle>상태</StatusHeaderTitle>
          <StatusHeaderBtn onClick={() => setIsAdd(true)}>추가</StatusHeaderBtn>
        </StatusHeader>
        <Table dataSource={statusList} columns={ IsMobile ? mobileColumns : columns} bordered={true} />
      </StatusWrapper>
      {isEdit && <StatusEdit setIsEdit={setIsEdit} data={data} />}
      {isAdd && <StatusAdd setIsAdd={setIsAdd} />}
    </Display>
  )
}

export default React.memo(Status)